// extracted by css-extract-rspack-plugin
export default {"CtaBanner":"CtaBanner-module__CtaBanner__nIU7lAS","CtaBanner__container":"CtaBanner-module__CtaBanner__container__eBsLqpL"};